/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Tab_Pending_CancelInputs */

const en_settings_billing_tab_pending_cancel = /** @type {(inputs: Settings_Billing_Tab_Pending_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending Cancel`)
};

const zh_settings_billing_tab_pending_cancel = /** @type {(inputs: Settings_Billing_Tab_Pending_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待取消`)
};

/**
* | output |
* | --- |
* | "Pending Cancel" |
*
* @param {Settings_Billing_Tab_Pending_CancelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_tab_pending_cancel = /** @type {((inputs?: Settings_Billing_Tab_Pending_CancelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Tab_Pending_CancelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_tab_pending_cancel(inputs)
	return zh_settings_billing_tab_pending_cancel(inputs)
});
export { settings_billing_tab_pending_cancel as "settings.billing.tab_pending_cancel" }